import { Box, Typography } from "@mui/material";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";

const MultiPaymentOption = ({
  title,
  iconPath,
  color,
  onProceedClick,
  disabled,
}) => {
  return (
    <Box>
      <Box
        sx={{
          borderRadius: disabled ? "16px 16px 0px 0px" : "16px",
          boxShadow: "2px 4px 15px rgba(0, 0, 0, 0.1)",
          padding: "8px 16px",
          margin: 2,
          mt: 0,
          display: "flex",
          justifyContent: "space-between",
          opacity: disabled ? 0.6 : 1,
          backgroundColor: disabled ? "rgba(28, 28, 28, 0.1)" : "#FFFFFF",
        }}
        onClick={disabled ? () => {} : onProceedClick}
      >
        <img src={iconPath} height={25} alt={title} />
        <Typography
          fontWeight={700}
          sx={{
            fontSize: "12px",
            display: "flex",
            alignItems: "center",
            color: color,
          }}
        >
          Pay To {title}
          <ArrowForwardRoundedIcon sx={{ marginLeft: 0.5 }} />
        </Typography>
      </Box>
      {disabled && (
        <Typography
          sx={{
            margin: 2,
            mt: -2,
            padding: 0.5,
            textAlign: "center",
            fontSize: "12px",
            backgroundColor: "rgba(216, 216, 216, 0.2)",
            borderRadius: "0px 0px 16px 16px",
            borderTop: "1px solid white",
          }}
        >
          You don't have any {title} outstanding
        </Typography>
      )}
    </Box>
  );
};

export default MultiPaymentOption;
